(() => {
  if (window.__vqAsciiArtLogged) return;
  window.__vqAsciiArtLogged = true;

  if (typeof console === 'undefined' || typeof console.log !== 'function') return;

  const badgeStyle = [
    'display: inline-block',
    'font-size: 14px',
    'font-weight: 600',
    'background: linear-gradient(to right, #FDCA40, #F16F24, #6B1755, #A80854, #E32340)',
    'color: #F5F2E4',
    'padding: 4px 8px',
    'border-radius: 4px'
  ].join(';');

  let message = '\n\n';
  message += 'VISIQUE ist eine kreative Agentur fuer moderne Websites und Online-Shops.\n';
  message += 'Mit massgeschneiderten Loesungen und enger Zusammenarbeit bringt das Team\n';
  message += 'die digitale Praesenz seiner Kunden auf ein neues Level.\n\n';
  message += 'Mehr erfahren unter www.visique.de\n\n';

  console.group('%cPowered by VISIQUE', badgeStyle);
  console.log(`%c${message}`, 'font-size: 14px;');
  console.groupEnd();
})();
